import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const UnifiedHeader = ({ className = "" }) => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        .unified-navbar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          z-index: 1000;
          padding: 1rem 0;
        }
        
        .unified-nav-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2rem;
        }
        
        .unified-logo {
          font-family: 'Orbitron', monospace;
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .unified-logo-cat {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
        }
        
        .unified-logo-main {
          font-size: 1.8rem;
          font-weight: 900;
          background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: unified-gradient 3s ease infinite;
        }
        
        .unified-logo-sub {
          font-size: 0.7rem;
          font-weight: 400;
          color: #96ceb4;
          margin-top: -2px;
        }
        
        .unified-nav-links {
          display: flex;
          list-style: none;
          gap: 2rem;
          margin: 0;
          padding: 0;
        }
        
        .unified-nav-links a {
          color: #ffffff;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.3s ease;
          position: relative;
        }
        
        .unified-nav-links a:hover {
          color: #4ecdc4;
        }
        
        .unified-nav-links a::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
          transition: width 0.3s ease;
        }
        
        .unified-nav-links a:hover::after {
          width: 100%;
        }
        
        @keyframes unified-gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        @media (max-width: 768px) {
          .unified-nav-container {
            padding: 0 1rem;
          }
          
          .unified-logo-main {
            font-size: 1.5rem;
          }
          
          .unified-logo-sub {
            font-size: 0.6rem;
          }
          
          .unified-nav-links {
            display: none;
          }
        }
      ` }), _jsx("nav", { className: `unified-navbar ${className}`, children: _jsxs("div", { className: "unified-nav-container", children: [_jsxs("div", { className: "unified-logo", children: [_jsx("img", { src: "/assets/cat-avatar.png", alt: "\u53E3\u888B\u88E1\u7684\u8C93", className: "unified-logo-cat" }), _jsxs("div", { children: [_jsx("div", { className: "unified-logo-main", children: "Sonic Pulse" }), _jsx("div", { className: "unified-logo-sub", children: "\uD83D\uDC31 \u53E3\u888B\u88E1\u7684\u8C93" })] })] }), _jsxs("ul", { className: "unified-nav-links", children: [_jsx("li", { children: _jsx("a", { href: "/", children: "\u9996\u9801" }) }), _jsx("li", { children: _jsx("a", { href: "/#tools", children: "\u5DE5\u5177" }) }), _jsx("li", { children: _jsx("a", { href: "/#channel", children: "\u983B\u9053" }) }), _jsx("li", { children: _jsx("a", { href: "/#contact", children: "\u806F\u7E6B" }) })] })] }) })] }));
};
export default UnifiedHeader;
